"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _apiClient = _interopRequireDefault(require("hub-http/clients/apiClient"));

var BASE_URL = 'app-users/v1/teams';
var _default = {
  fetchTeams: function fetchTeams() {
    return _apiClient.default.get(BASE_URL);
  }
};
exports.default = _default;
module.exports = exports.default;